import * as React from 'react';
// @ts-ignore
import Fieldset from 'components/Fieldset';

import { ProposedGroup } from './SetupRosterChoose';

type Props = {
  proposedGroups: Array<ProposedGroup>;
};

export default function SetupRosteredClassesList({ proposedGroups }: Props) {
  const classes = proposedGroups.map(group => {
    return (
      <tr key={group.class_name}>
        <td className="SetupRosterLoading-name">{group.class_name}</td>
        <td>{group.student_count} students</td>
      </tr>
    );
  });

  return (
    <Fieldset>
      <table className="SetupRosterLoading-table">
        <tbody>{classes}</tbody>
      </table>
    </Fieldset>
  );
}
